import { europeanConstant } from "../_constants/european.constant";
import { faqsConstant } from "../_constants/faqDetails.contant";
import { europeanService } from "../_services/european.service";
import { faqService } from "../_services/faqDetails.service";
import { alert } from "../_utilities/alert";
import { configes } from "../webData";

export const faqAction = {
  getFaqDetails,
};


function getFaqDetails() {
  return (dispatch) => {
    dispatch(
      dispatchFunction({
        type: faqsConstant.GET_FAQS_REQUEST,
        data: null,
      })
    );
    faqService
    .getFaqDetails()
    .then(
      (response) => {
        if (response.Status === 200) {
          dispatch(
            dispatchFunction({
              type: faqsConstant.GET_FAQS_SUCCESS,
              data: response.Result.faqs,
            })
          );
        } else {
          dispatch(
            dispatchFunction({
              type: faqsConstant.GET_FAQS_FAILURE,
              data: null,
            })
          );
        }
      },
      (error) => {
        dispatch(
          dispatchFunction({
            type: faqsConstant.GET_FAQS_FAILURE,
            data: error,
          })
        );
      }
    );
  };
}

function dispatchFunction(data) {
  return {
    type: data.type,
    data: data.data,
  };
}
